<template>
  <div>
      <Card dis-hover style="min-height:400px;">
        <Form ref="queryForm" :label-width="80" label-position="left" inline>
          <FormItem label="签订方式:">
            <Select v-model="query.signingMode" style="width: 120px">
              <Option value=""> -- </Option>
              <Option :value="product.value" v-for="(product,index) in signingModeData" :key="index">{{product.name}}</Option>
            </Select>
          </FormItem>
		  <FormItem label="签订周期:">
		    <Select v-model="query.signingCycle" style="width: 120px">
		      <Option value=""> -- </Option>
		      <Option :value="product.value" v-for="(product,index) in signingCycleData" :key="index">{{product.name}}</Option>
		    </Select>
		  </FormItem>
		  <FormItem label="付款方式:">
            <Select v-model="query.payType" style="width: 120px">
              <Option value=""> -- </Option>
              <Option :value="product.value" v-for="(product,index) in payTypeData" :key="index">{{product.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="创建时间:">
            <DatePicker v-model="query.createTime" type="daterange" @on-change="dateChange" style="width: 200px" placement="bottom-end" placeholder="请选择"></DatePicker>
          </FormItem>
          <FormItem :label-width="20">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
          </FormItem>
          <!-- </Row> -->
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </Card>
    <div v-if="createLogModelShow">
      <createContract :show="createLogModelShow" @close="closeModel" :customerId="customerId" :quotationId="quotationId" :isDetail="isDetail"></createContract>
    </div>
  </div>
</template>
<script>
import Util from '../../../lib/util'
import createContract from './createContract.vue'
export default {
  components: { createContract },
  props: {
    show: Boolean,
    customerId: Number,
	isDetail:Boolean
  },
  data() {
    return {
      model: true,
      query: {
        createTime: [],
        signingMode: null,
        signingCycle: null,
        payType: null,
        createTimeStart: '',
        createTimeEnd: '',
        customerId: this.customerId,
      },
      header: {
        Authorization: `Bearer ${Util.abp.auth.getToken()}`,
      },
	  isDisable:false,
      columns: [], //项目表头
      list: [], //项目数据
      signingModeData:[],
      signingCycleData:[],
      payTypeData:[],
      pageSize: 10,
	  quotationId:null,
      currentPage: 1,
      totalCount: 0,
      loading: false,
      createLogModelShow: false,
    }
  },
  mounted() {
	this.getSelect()
    this.getColumns()
    this.getpage(1)
	if(this.isDetail)
		this.isDisable=this.isDetail
  },
  methods: {
	//   获取下拉框数据
	async getSelect() {
	  const { data } = await this.$Ajax.get(
	    `/api/services/app/CustomerContractApiService/GetContractMgrInitData?customerId=${this.customerId}`
	  )
	  this.contactsData = data.result.contactsData
	  this.signingModeData = data.result.signingModeData
	  this.signingCycleData = data.result.signingCycleData
	  this.accountPeriodData = data.result.accountPeriodData
	  this.payTypeData = data.result.payTypeData
	},
    getColumns() {
      this.columns = [
        {
          title: '签订方式',
          key: 'signingModeText',
          toolbar:true,
        },
        {
          title: '合同签订周期',
          key: 'signingCycleText',
        },
		{
          title: '付款方式',
          key: 'payTypeText',
        },
        {
          title: '联系人',
          key: 'contactsIdsText',
        },
		{
          title: '账期',
          key: 'accountPeriodText',
        },
        {
          title: '创建时间',
          key: 'creationTimeText',
        },
        {
          title: '操作',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
				    },
				    style: {
				      marginRight: '5px',
				      display: this.isDisable ? '' : 'none',
				    },
				    on: {
				      click: () => {
				        this.openCreateProduct(params.row.id)
				      },
				    },
				  },
				  '详情'
				),	
            ])
          },
        },
       
      ]
    },
    // 关闭弹窗
    close(refresh) {
      this.$emit('close', refresh)
    },
    closeModel(refresh) {
      this.createLogModelShow = false
      this.quotationId=0
	  if(refresh){
        this.getpage(1)
      }
    },
    //新增日志
    openCreateLog() {
      this.createLogModelShow = true
    },
    //时间改变
    dateChange() {
      let time = this.query.createTime
      let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
      let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
      this.query.createTimeStart = start
      this.query.createTimeEnd = end
    },
    async getpage(params) {
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }

      this.loading = true
      const data = await this.$Ajax.get('/api/services/app/CustomerContractApiService/QueryDto', {
        params: this.query,
      })
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.loading = false
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
	// 创建产品
	openCreateProduct(quotationId) {
	  this.quotationId = quotationId
	  this.createLogModelShow = true
	},
    reset() {
      this.query = {
        createTime: [],
        signingMode: null,
        signingCycle: null,
        payType: null,
        createTimeStart: '',
        createTimeEnd: '',
        customerId: this.customerId,
      }
      this.getpage(1)
    },
  },
}
</script>
<style lang="less" scoped>
// /deep/.ivu-modal-fullscreen {
//   width: calc(~'100% - 256px') !important;
//   top: 0;
//   bottom: 0;
//   position: absolute;
//   left: 256px;
// }
</style>